import { render, staticRenderFns } from "./FuncBar.vue?vue&type=template&id=3a22df7d"
import script from "./FuncBar.vue?vue&type=script&lang=js"
export * from "./FuncBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports